/**
 * Created : vincent
 * Date : 2018/5/10  5:24 PM
 * Email : wangxiao@wafersystems.com
 */
import React from 'react';
import _ from 'lodash';
import { DatePicker, message, Modal, Spin, Table, Tree } from 'antd';
import CustomChart from './CustomChart';
import Top5List from './Top5List';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { CHINESE, ENGLISH } from '../../utils/constants';

const TreeNode = Tree.TreeNode;

export default class FaultStatistics extends React.Component {
  constructor(props) {
    super(props);
    this.onStartChange = this.onStartChange.bind(this);
    this.onStartOk = this.onStartOk.bind(this);
    this.onEndChange = this.onEndChange.bind(this);
    this.onEndOk = this.onEndOk.bind(this);
    this.search = this.search.bind(this);
    this.state = {
      startTime: moment().add(-7, 'd'),
      endTime: moment()
    };
  }

  componentDidMount() {
    const { areaData } = this.props.account;
    this.props.dispatch({
      type: 'fault/getRoomByArea',
      startTime: this.state.startTime,
      endTime: this.state.endTime,
      zoneId: areaData.id
    });
  }

  onStartChange(value) {
    this.setState({ startTime: value });
  }

  onStartOk(value) {
    this.setState({ startTime: value });
  }

  onEndChange(value) {
    this.setState({ endTime: value });
  }

  onEndOk(value) {
    this.setState({ endTime: value });
  }

  search() {
    if (!this.state.startTime || !this.state.endTime) {
      Modal.warning({
        content: this.props.intl.formatMessage({
          id: 'fault_select_time_placeholder'
        })
      });
      return;
    }
    if (this.state.startTime.isAfter(this.state.endTime)) {
      Modal.warning({
        content: this.props.intl.formatMessage({ id: 'fault_time_error' })
      });
      return;
    }
    if (!this.props.fault.rooms.length === 0) {
      Modal.warning({
        content: this.props.intl.formatMessage({ id: 'fault_zone_error' })
      });
      return;
    }
    const temp = this.props.fault.rooms.map(v => v.id);
    this.props.dispatch({
      type: 'fault/findBoardFaultList',
      startTime: this.state.startTime.format('YYYY-MM-DD HH:mm:ss'),
      endTime: this.state.endTime.format('YYYY-MM-DD HH:mm:ss'),
      roomIds: temp.join(',')
    });
  }

  render() {
    const { intl, account, loading, fault } = this.props;
    const en = intl.locale === 'en_US';
    const { areaData } = account;
    const { tables } = fault;
    let dataArray = [];
    if (tables) {
      let roomName = '',roomNameEn = '';
      let data;
      for (let i = 0; i < tables.length; i++) {
        if (tables[i].roomName !== roomName) {
          roomName = tables[i].roomName;
          roomNameEn = tables[i].roomNameEn;
          data = {
            roomName: tables[i].roomName,
            roomNameEn: tables[i].roomNameEn,
            values: [],
            key:tables[i].id+''
          };
          dataArray.push(data);
        }
        data.values.push({
          boardDesc: tables[i].boardDesc,
          frqcy: tables[i].frqcy
        });
      }
    }
    return (
      <div className="fault-page">
        <Spin spinning={false} size="large">
          <div className="container-desk">
            <div className="information-panel">
              <div className="info-cont">
                <div className="user-left">
                  <div className="information-title">
                    {en ? (
                      'Yesterday'
                    ) : (
                      <FormattedMessage id="fault_yesterday_fault_statistics" />
                    )}
                  </div>
                  <div className="type">
                    <span className="name">
                      <FormattedMessage id="fault_number_of_failures" />:
                    </span>
                    <span
                      className="text"
                      title={fault.number == null ? '' : fault.number}
                    >
                      {fault.number == null ? '' : fault.number}
                    </span>
                    {!en && (
                      <span className="name unit">
                        <FormattedMessage id="fault_times" />
                      </span>
                    )}
                    <br />
                    <span className="name">
                      <FormattedMessage id="fault_failures_rate" />:
                    </span>
                    <span
                      className="text"
                      title={fault.rate == null ? '' : fault.rate}
                    >
                      {fault.rate == null ? '' : Number(fault.rate).toFixed(2)}
                    </span>
                    <span className="name unit">%</span>
                  </div>
                </div>
              </div>
              <div className="info-cont">
                <div className="user-left">
                  <div className="information-title">
                    <FormattedMessage id="fault_7_fault_statistics" />
                  </div>
                  <div className="type info-block">
                    <span className="name">
                      <FormattedMessage id="fault_number_of_failures" />:
                    </span>
                    <span
                      className="text"
                      title={fault.number_7 == null ? '' : fault.number_7}
                    >
                      {fault.number_7 == null ? '' : fault.number_7}
                    </span>
                    {!en && (
                      <span className="name unit">
                        <FormattedMessage id="fault_times" />
                      </span>
                    )}
                    <br />
                    <span className="name">
                      <FormattedMessage id="fault_failures_rate" />:
                    </span>
                    <span
                      className="text"
                      title={fault.rate_7 == null ? '' : fault.rate_7}
                    >
                      {fault.rate_7 == null
                        ? ''
                        : Number(fault.rate_7).toFixed(2)}
                    </span>
                    <span className="name unit">%</span>
                  </div>
                </div>
              </div>
              <div className="info-cont">
                <div className="user-left">
                  <div className="information-title">
                    <FormattedMessage id="fault_7_fault_number" />
                  </div>
                  <div className="type">
                    <CustomChart
                      data={fault.fault_7}
                      value={'frqcy'}
                      label={'date'}
                      locals={intl.locale}
                    />
                  </div>
                </div>
              </div>
              <div className="info-cont">
                <div className="user-left">
                  <div className="information-title">
                    <FormattedMessage id="fault_top5" />
                  </div>
                  <div className="type">
                    <Top5List
                      data={fault.fault_top5}
                      value={'frqcy'}
                      label={intl.locale === ENGLISH?'roomNameEn':'roomName'}
                      locals={intl.locale}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="list-body">
              <div className="monitor-body">
                <div className="monitor-area">
                  <div className="monitor-area-body">
                    {!_.isEmpty(areaData) && (
                      <Tree
                        onSelect={(selectedKeys, e) => {
                          let areaObj = e.node && e.node.props.obj;
                          this.props.dispatch({
                            type: 'fault/getRoomByArea',
                            zoneId: areaObj.id || '',
                            startTime: this.state.startTime,
                            endTime: this.state.endTime
                          });
                        }}
                      >
                        {this.recursionArea(areaData.child)}
                      </Tree>
                    )}
                  </div>
                </div>
                <div className="monitor-table2">
                  <div className="search">
                    <DatePicker
                      showTime
                      className="report-div report-date"
                      format="YYYY-MM-DD HH:mm"
                      value={this.state.startTime}
                      placeholder={intl.formatMessage({
                        id: 'fault_select_time_placeholder'
                      })}
                      onChange={this.onStartChange}
                      onOk={this.onStartOk}
                    />
                    &nbsp; — &nbsp;
                    <DatePicker
                      showTime
                      value={this.state.endTime}
                      className="report-div report-date"
                      format="YYYY-MM-DD HH:mm"
                      placeholder={intl.formatMessage({
                        id: 'fault_select_time_placeholder'
                      })}
                      onChange={this.onEndChange}
                      onOk={this.onEndOk}
                    />
                    <button className="search_button" onClick={this.search}>
                      <FormattedMessage id="fault_search_button" />
                    </button>
                  </div>
                  <Table
                    columns={this.getColumns()}
                    dataSource={dataArray}
                    pagination={false}
                    scroll={{ y: 680 }}
                    locale={{
                      emptyText: intl.formatMessage({
                        id: 'smart_device_drop_down_no_data'
                      })
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    );
  }

  recursionArea = areaList => {
    let treeHtml = [];
    areaList &&
      areaList.map(area => {
        if (area.child && area.child.length > 0) {
          treeHtml.push(
            <TreeNode key={String(area.id)} title={area.name} obj={area}>
              {this.recursionArea(area.child)}
            </TreeNode>
          );
        } else {
          treeHtml.push(
            <TreeNode key={String(area.id)} title={area.name} obj={area} />
          );
        }
      });
    return treeHtml;
  };

  getColumns = () => {
    const { intl } = this.props;
    return [
      {
        title: intl.formatMessage({ id: 'monitor_panel_room_name' }),
        dataIndex: intl.locale === ENGLISH?'roomNameEn':'roomName',
        width: '30%',
        render: (text, record) => {
          return (
            <div className="tbody-row-name" title={intl.locale === ENGLISH?record.roomNameEn:record.roomName}>
              <span>
                {intl.locale === ENGLISH?
                record.roomNameEn.length > 15
                  ? record.roomNameEn.slice(0, 15) + '...'
                  : record.roomNameEn:
                record.roomName.length > 9
                  ? record.roomName.slice(0, 9) + '...'
                  : record.roomName}
              </span>
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({ id: 'monitor_panel_position' }),
        dataIndex: 'boardDesc',
        width: '45%',
        render: (text, record) => {
          return (
            <div>
              {record.values.map(v => (
                <div
                  key={'desc' + v.boardDesc + record.key}
                  className="tbody-row tbody-row-position"
                >
                  <span>{v.boardDesc}</span>
                </div>
              ))}
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({ id: 'fault_number_of_failures_title' }),
        dataIndex: 'frqcy',
        width: '25%',
        render: (text, record) => {
          return (
            <div>
              {record.values.map(v => (
                <div
                  key={'f' + v.boardDesc + record.key}
                  className="tbody-row frqcy"
                >
                  <span>{v.frqcy}</span>
                </div>
              ))}
            </div>
          );
        }
      }
    ];
  };
}



// WEBPACK FOOTER //
// ./src/components/monitor/FaultStatistics.js